<div class="chart-container" #containerRef [style.height.px]="graphHeight()">
    <ngx-charts-bar-horizontal
        [view]="[containerRef.offsetWidth, containerRef.offsetHeight]"
        [scheme]="colorScheme"
        [results]="results"
        [gradient]="gradient"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [showXAxisLabel]="showXAxisLabel"
        [showYAxisLabel]="showYAxisLabel"
        [yAxisLabel]="yAxisLabel"
        [xAxisLabel]="xAxisLabel"
        [showDataLabel]="showDataLabel"
        [showGridLines]="true" />
</div>
